var _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLeadstatsLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 256.21 193.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "aacf242a-dfec-49b7-a252-78df34dfe6b8",
    x1: 186.43,
    y1: 168.25,
    x2: 19.34,
    y2: 1.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "aqua"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#842bd0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#ff007e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffe800"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 30") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "b42b130b-5db6-4b0e-a316-05b122ff8910",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a18469ee-8bbc-4ed5-bd1b-1c2c574e6854",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a35a5409-d70f-47d5-9913-a364ccc809eb",
    "data-name": "SVGID",
    d: "M194.11,98.23c-.44,7.84-1.28,15.72-2.31,23.41-2,14.49-5.05,32.81-10.54,46.37-4.89,12.09-13.95,21.92-27.07,24.72s-28.89-.57-36.81-12H47.67a6.2,6.2,0,0,1-6.19-6.19h0a6.2,6.2,0,0,1,6.19-6.19H113c-.56-8.19,2.89-16.48,7.85-23.48H54.49a6.2,6.2,0,0,1-6.18-6.19h0a6.2,6.2,0,0,1,6.18-6.19h75.68a79.84,79.84,0,0,0,8-13.69q3-6.33,5.39-12.78H72.85a6.21,6.21,0,0,1-6.19-6.19h0a6.21,6.21,0,0,1,6.19-6.19h50.22l-1.23-.36C102.77,87.5,93.22,79,90.25,69.37H58.86a6.21,6.21,0,0,1-6.19-6.19h0A6.21,6.21,0,0,1,58.86,57H89.75c1.88-9.46,8.42-19.18,17.27-27.75H47.33a6.21,6.21,0,0,1-6.19-6.19h0a6.21,6.21,0,0,1,6.19-6.19h75.28q2.74-1.8,5.57-3.42C142.89,5,159.34-.13,176.39,0,232.57.45,290.8,68.22,231,90.39a137.4,137.4,0,0,1-36.67,7.82l-.25,0ZM8.1,168.34h14a6.2,6.2,0,0,1,6.19,6.19h0a6.2,6.2,0,0,1-6.19,6.19H8.1a6.21,6.21,0,0,1-6.19-6.19h0a6.21,6.21,0,0,1,6.19-6.19Zm7.58-35.86h14a6.2,6.2,0,0,1,6.18,6.19h0a6.2,6.2,0,0,1-6.18,6.19h-14a6.21,6.21,0,0,1-6.19-6.19h0a6.21,6.21,0,0,1,6.19-6.19ZM35.59,93.63h14a6.2,6.2,0,0,1,6.18,6.19h0A6.19,6.19,0,0,1,49.57,106h-14a6.2,6.2,0,0,1-6.19-6.19h0a6.21,6.21,0,0,1,6.19-6.19ZM19.11,57h14a6.21,6.21,0,0,1,6.19,6.19h0a6.21,6.21,0,0,1-6.19,6.19h-14a6.2,6.2,0,0,1-6.19-6.19h0A6.21,6.21,0,0,1,19.11,57ZM6.19,16.86h14a6.21,6.21,0,0,1,6.19,6.19h0a6.21,6.21,0,0,1-6.19,6.19h-14A6.2,6.2,0,0,1,0,23.05H0a6.21,6.21,0,0,1,6.19-6.19ZM193.74,88.79a131.62,131.62,0,0,0,34-7.25c8.69-3.22,25.26-11.46,15.16-21.17C219.1,37.49,126.16,38.77,103.57,59,85,75.65,133.68,89.06,149.72,88.5c.11-.41.21-.83.32-1.25,1.63-6.75,4.64-13.58,10-18.23a19.46,19.46,0,0,1,16.9-4.77c10.76,2.21,16.88,12.56,16.85,23,0,.5,0,1,0,1.52Z",
    style: {
      fillRule: "evenodd",
      fill: "url(#aacf242a-dfec-49b7-a252-78df34dfe6b8)"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeadstatsLogo);
export default __webpack_public_path__ + "static/media/leadstats-logo.ea8ec9cb07b957d871cf6a44a0bac491.svg";
export { ForwardRef as ReactComponent };